import React, { useEffect, useState } from 'react';

import { Button, Card, Skeleton } from 'antd';

import MonitorPage from '../monitor/MonitorPage';

import { monitorAPI } from '../../http/MonitorAPI';
import { LiveStation } from '../../models/StationsLive';

const StationDataPage = () => {
    const [hasStations, setHasStations] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const load = () => {
        setLoading(true);
        monitorAPI
            .GetStationsLive()
            .then((data) => {
                const mine = (data || []).filter((s) => s.mine);
                setHasStations(mine.length > 0);
            })
            .catch(() => setHasStations(false))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        load();
    }, []);

    if (loading) {
        return <Skeleton active paragraph={{ rows: 4 }} />;
    }

    if (!hasStations) {
        return (
            <div className="empty-box">
                <h3>У вас пока нет станции</h3>
                <p>
                    Станция на поле измеряет влажность и температуру почвы на разных глубинах — там, где развивается
                    корневая система культуры. Это не средние метеоданные по району, а точные показатели вашего поля:
                    достаточно ли влаги, прогрелась ли почва для сева, как культура переносит засуху и переувлажнение.
                </p>
                <Button type="primary">Как получить станцию</Button>
            </div>
        );
    }

    return (
        <Card bodyStyle={{ padding: 12 }}>
            <MonitorPage />
        </Card>
    );
};

export default StationDataPage;
